"use client";
import { useRouter } from "next/navigation";
import { IconButton } from "@mui/material";
import { ArrowBack as BackArrow } from "@mui/icons-material";

import { useStore, observer } from "../../../../service/mobx";

function BackButton() {
  const { analytics, reader } = useStore();
  const router = useRouter();

  return reader.whiteLabelled ? null : (
    <IconButton
      aria-label="Back"
      size="small"
      onClick={() => {
        try {
          var history = JSON.parse(sessionStorage.getItem("history") || "[]");
        } catch {
          history = [];
        }

        for (const url of history) {
          if (url.startsWith("/docs") === false) {
            var previousUrl = url;
            break;
          }
        }

        router.push(previousUrl || "/");
        analytics.track.event("Back Click");
      }}
    >
      <BackArrow sx={{ color: "surface.on.color" }} />
    </IconButton>
  );
}

export default observer(BackButton);
